/**
 * Dados para montagem do menu
 * se possuir parametro itens é um agrupamento de links (colapse)
 */

/**
 * Cria um novo link
 *
 * @param string label
 * @param string link
 * @param string icon
 * @param string roles
 * @param string permissions
 * @returns {{roles: *, link: *, icon: *, label: *}}
 */
const newLink = function ({ label, link, roles = '', permissions = '', icon = 'remove' }) {
  return {
    label: label,
    link: link,
    icon: icon,
    roles: roles,
    permissions: permissions,
  }
}
/**
 * Cria um novo grupo de links menu colapse
 *
 * @param string label
 * @param string icon
 * @param string roles
 * @returns {{roles: *, link: *, icon: *, label: *}}
 */
const linkGroup = function ({ label, roles = '', icon, items = [] }) {
  let category = {
    label: label,
    roles: roles,
    icon: icon,
    items: items,
  }
  return category
}

const dashboardLinks = [
  newLink({
    label: 'Geral',
    link: '/dashboard',
    roles: 'admin|analista|visitante',
  }),
  newLink({
    label: 'Resultados',
    link: '/dashboard-resultados',
    roles: '', // herda permissão do grupo
  }),
  newLink({
    label: 'Busca Painel Cruzamentos',
    link: '/painel-cruzamentos/busca',
    roles: '', // herda permissão do grupo
  }),
  newLink({
    label: 'Back Office',
    link: '/backoffice/home',
    roles: '', // herda permissão do grupo
  }),
]

const dashboard = linkGroup({
  label: 'Dashboard',
  roles: 'admin|operacao|call-center|assessor|visitante|analista',
  icon: 'dashboard',
  items: dashboardLinks,
})

const parameterLinks = [
  newLink({
    label: 'Controle de acesso',
    link: '/spa/system/roles',
    roles: '',
    permissions: 'gerenciar permissoes',
  }),
  newLink({
    label: 'Dias úteis',
    link: '/calendario-dias-uteis',
    roles: '',
  }),
  newLink({
    label: 'Data Bloqueio Pagamento',
    link: '/spa/parameters/block-payment-edition',
    roles: '',
    permissions: 'alterar data_bloqueio_edicao_pagamentos',
  }),
  newLink({
    label: 'Restrições Permitidas SPC',
    link: '/parametros/restricoes-spc',
    roles: '',
  }),
  newLink({
    label: 'IOF',
    link: '/spa/parameters/iof',
    roles: '',
    permissions:'gerenciar iof',
  }),
  newLink({
    label: 'Bairros conhecidos',
    link: '/parametros/bairros-conhecidos',
    roles: '',
  }),
  newLink({
    label: 'Endereços conhecidos',
    link: '/parametros/enderecos-conhecidos',
    roles: 'admin',
  }),
  newLink({
    label: 'tags',
    link: '/visualizar-tags',
    roles: '',
  }),
]

const parameters = linkGroup({
  label: 'Parâmetros',
  roles: 'admin',
  icon: 'build',
  items: parameterLinks,
})

const searchCpfCnpj = newLink({
  label: 'Consulta CPF/CNPJ',
  link: '/consulta-cpf',
  roles: 'admin|operacao|call-center|assessor|visitante|analista', // herda permissão do grupo
  icon: 'search',
})

const creditAlert = newLink({
  label: 'Alerta de Crédito',
  link: '/aviso-renovacao',
  roles: 'admin|assessor|analista|operacao|call-center',
  icon: 'warning',
})

const aprovationLinks = [
  newLink({
    label: 'Mesa de crédito',
    link: '/formularios-aprovacao',
    roles: '',
    permissions: 'aprovar solicitacao'
  }),
  newLink({
    label: 'Agenda desembolso',
    link: '/operation/schedule',
    roles: '',
  }),
]
const aprovations = linkGroup({
  label: 'Aprovações',
  roles: 'admin|visitante|operacao|call-center|analista|assessor',
  icon: 'thumb_up',
  items: aprovationLinks,
})

const charging = newLink({
  label: 'Cobrança',
  roles: '', //definir as roles
  icon: 'thumb_up',
  link: '/spa/charges',
})

const billets = newLink({
  label: 'Emitir boletos',
  link: '/criar-faturas',
  roles: 'admin|visitante|operacao|call-center',
  icon: 'receipt',
})
const clientPhotos = newLink({
  label: 'Fotos cliente',
  link: '/clientes/fotos',
  roles: 'admin|operacao|call-center|visitante|analista|assessor',
  icon: 'camera_alt',
})

const clients = newLink({
  label: 'Clientes',
  link: '/spa/clients',
  roles: 'admin|operacao|call-center|visitante|analista|assessor',
  icon: 'group',
})

const clientsReview = newLink({
  label: 'Clientes Revisão',
  link: '/spa/clients-review',
  roles: 'admin|operacao|call-center|visitante|analista|assessor',
  icon: 'group',
})

const allSolicitations = newLink({
  label: 'Solicitações',
  link: '/formularios',
  roles: 'admin|operacao|call-center|visitante|analista|assessor',
  icon: 'note',
})

const products = newLink({
  label: 'Produtos',
  link: '/spa/products',
  roles: 'admin|operacao|call-center|visitante|analista|assessor',
  icon: 'store',
})

const reportsLinks = [
  newLink({
    label: 'Cobrança avulsa',
    link: '/spa/reports/detached-charges',
    roles: 'admin|operacao|call-center',
  }),
  newLink({
    label: 'Operacional',
    link: '/spa/reports',
    roles: 'admin|operacao|call-center|visitante',
  }),
  newLink({
    label: 'Financeiros',
    link: '/spa/financing/reports',
    roles: 'admin|operacao|call-center|visitante',
  }),
  newLink({
    label: 'Promotores',
    link: '/relatorios/cadastro-promotores',
    roles: 'admin|visitante',
  }),
  newLink({
    label: 'Representantes',
    link: '/contratos/representantes/relatorio',
    roles: 'admin|visitante',
  }),
  newLink({
    label: 'Solicitação de clientes',
    link: '/relatorios/visualizar-solicitacao-cliente',
    roles: 'admin|visitante',
  }),
]
const reports = linkGroup({
  label: 'Relatórios',
  roles: 'admin|operacao|call-center|visitante',
  icon: 'list_alt',
  items: reportsLinks,
})

const clientsMap = newLink({
  label: 'Mapa de Clientes',
  link: '/clientes/mapa',
  roles: 'admin|visitante',
  icon: 'map',
})

const simplifiedRegister = newLink({
  label: 'Cadastro simplificado',
  link: '/cadastrar-cliente-simplificado',
  roles: 'admin|operacao|call-center|analista|assessor',
  icon: 'person_add',
})

// const clientRegister = newLink({
//   label: 'Cadastrar completo',
//   link: '/cadastrar-cliente',
//   roles: 'assessor|promotor|admin|analista|operacao|call-center',
//   icon: 'person_add',
// })

const myClients = newLink({
  label: 'Meus cadastros',
  link: '/formularios-salvos',
  roles: 'admin|assessor|promotor|analista|operacao|call-center',
  icon: 'group',
})

const targetLinks = [
  newLink({
    label: 'Metas Assessores',
    link: '/metas-assessores',
    roles: '',
  }),
  newLink({
    label: 'Metas promotores',
    link: '/metas-promotores',
    roles: 'admin|visitante',
  }),
]

const targets = linkGroup({
  label: 'Metas',
  roles: 'admin|assessor|visitante',
  icon: 'star_rate',
  items: targetLinks,
})

const simulation = newLink({
  label: 'Simular Parcelas',
  link: '/disbursements/simulator',
  roles: '', // sem permissões : qualquer que estiver logado?
  icon: 'view_list',
})

const users = newLink({
  label: 'Usuários',
  link: '/spa/system/users',
  roles: 'admin',
  icon: 'person',
})

const resetPassword = newLink({
  label: 'Alterar senha',
  link: '/alterar-senha',
  roles: '', // sem permissoes
  icon: 'person',
})

const history = newLink({
  label: 'Histórico offline',
  link: '/historico',
  roles: 'assessor|promotor|admin',
  icon: 'history',
})
const logout = newLink({
  label: 'Sair',
  link: '/logout',
  roles: '',
  icon: 'exit_to_app',
})

const menu = [
  dashboard,
  parameters,
  searchCpfCnpj,
  creditAlert,
  aprovations,
  charging,
  billets,
  clientPhotos,
  clients,
  clientsReview,
  allSolicitations,
  products,
  reports,
  clientsMap,
  simplifiedRegister,
  // clientRegister,
  myClients,
  targets,
  simulation,
  users,
  resetPassword,
  logout,
]

export default menu



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/menu-data.js